import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA  } from '@angular/material/dialog';

@Component({
  selector: 'gsp-login-error-modal',
  templateUrl: './login-error-modal.component.html',
  styleUrls: ['./login-error-modal.component.css'],

})
export class LoginErrorModalComponent implements OnInit {

  constructor(public thisDialogRef: MatDialogRef<LoginErrorModalComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any, private cd: ChangeDetectorRef) { 
      thisDialogRef.disableClose = true;
   
        }

  ngOnInit() {
    setTimeout(() => { this.cd.detectChanges(); });
        }
  onClose(value: string) {
    this.thisDialogRef.close(value);
  }
}
